module.exports = __webpack_public_path__ + "img/eematico-toys-team.991e5cbc.jpg";